export enum AlertTypeEnum {
    ROUTE_DEVIATION = 1,
    SIGNIFICANT_DELAY = 2,
    PROXIMITY = 3,
    EARLY_DEPARTURE = 4,
    MISSING_CIRCULATION = 5,
    EXCESSIVE_DRIVING = 6,
    SAME_SCHEDULE = 7
}